<div class="filter-button" [ngClass]="{'all-columns-button': selectedColumns?.length === columns?.length}">
	<button mat-button disableRipple="true" (click)="filterOp.toggle($event)">
		<mat-icon>settings</mat-icon>
	</button>
	<!-- <div class="types-info" *ngIf="filterIsOn">{{countTypes}} types</div> -->
</div>

<p-overlayPanel #filterOp [dismissable]="true" styleClass="columns-filter-panel">
	<div class="multiselect-block" [ngClass]="{'all-columns': selectedColumns?.length === columns?.length}">
		<div class="multiselect-label" style="font-size: 90%; color: #b1b1b1;">
			Columns Filter
		</div>

		<p-multiSelect #multiSelect [defaultLabel]="'Columns'" [selectedItemsLabel]="'{0} columns selected'"
			[options]="columns" [optionLabel]="'name'" [(ngModel)]="selectedColumns" [showToggleAll]="true"
			(onChange)="updateColumns($event)" [filter]="false" [maxSelectedLabels]="1" [styleClass]="!activePreset ? 'custom-active' : ''">
			<p-header (click)="showAll()">
				Show All
			</p-header>
		</p-multiSelect>
	</div>

	<div class="presets-block" *ngIf="presets?.length">
		<div class="presets-label" style="font-size: 90%; color: #b1b1b1; margin-top: 10px; margin-bottom: 5px;">
			Presets
		</div>
		<div class="preset-list">
			<div class="preset-item" *ngFor="let preset of presets" (click)="applyPreset(preset)" [class.active]="activePreset?.id === preset.id">
				<span>{{preset.title}}</span>
				<mat-icon *ngIf="activePreset?.id === preset.id">check</mat-icon>
			</div>
		</div>
	</div>
</p-overlayPanel>